import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Button } from '../../../shared/components/ui/buttons/gradient-btn/button';
import { OdinService } from '../../services/odin.service';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'andor-reconnecting-overlay',
  imports: [CommonModule, Button, TranslatePipe],
  templateUrl: './reconnecting-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './reconnecting-overlay.scss',
})
export class ReconnectingOverlay {
  @Input() colorMode = '';

  constructor(public odinService: OdinService) {}
}
